import { atom } from 'recoil';
import { FlowV2_Update_Metadata } from '~/graphql/types';

const metadata = atom<Array<FlowV2_Update_Metadata>>({
  key: 'flow-metadata',
  default: [],
});

export default metadata;
